<template>
    <div>
        <slot>
            <el-col>
                <div class="compare" v-for="item in items">
                    <span class="topTab">IP：{{ item.ip }}</span>
                    <span class="topTab">时间：{{ item.update_time }}</span>
                    <el-input v-model="item.result" placeholder="" :rows="11" class="allMessage" type="textarea" readOnly="true" />
                </div>
            </el-col>
        </slot>
    </div>
</template>
<script>
    import axios from 'axios';
    import api from '@/api/home';
export default {
    name: 'detailes',
    data(){
        return {
            items: [],
        }
    },
    created(){
        let ip = this.$route.query.ip
        api.Allresult({ip: ip}).then(res => {
            console.log(res)
            if (res.status == 200){
                this.items = res.data
            }
        })
    },
    mounted(){
        
    }
}
</script>
<style lang='scss' scoped>
.compare {
    margin-top: 10px;

    .showTip {
        float: left;
        font-size: 18px;
        font-weight: bold;
    }
    
    .topTab {
        display: inline-block;
        width: 240px;
        height: 25px;
        line-height: 30px;
        text-align: left;
        margin: 5px auto;
        float: left;
    }
}

</style>





// WEBPACK FOOTER //
// src/components/details.vue